<template>
  <div class="form-group">
    <div
      class="align-item"
      :class="{ active: value === 'left' }"
      @click="chooseAlign('left')"
    >
      <i class="uil uil-align-left"></i>
    </div>
    <div
      class="align-item"
      :class="{ active: value === 'center' }"
      @click="chooseAlign('center')"
    >
      <i class="uil uil-align-center"></i>
    </div>
    <div
      class="align-item"
      :class="{ active: value === 'right' }"
      @click="chooseAlign('right')"
    >
      <i class="uil uil-align-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      type: [String],
      default: '',
    },
  },

  methods: {
    chooseAlign(align) {
      this.$emit('input', align)
    },
  },
}
</script>

<style lang="scss" scoped>
.align-item {
  display: inline-block;
  border: 1px solid transparent;
  padding: 3px 5px 0px 5px;
  cursor: pointer;
  border-radius: 5px;
  margin-right: 6px;
  i {
    color: rgba(0, 27, 72, 0.54);
    font-size: 20px;
  }
  &.active {
    border-color: rgba(0, 27, 72, 0.12);
    color: rgba(0, 14, 36, 0.87);
  }
}
</style>
